<template>
    <b-card no-body v-if="details">
        <div class="card-body p-0">
            <div class="px-2">
                <b-alert show variant="warning mb-0">
                    <h3 class="alert-heading">Onay Talebi</h3>
                    <div class="alert-body font-weight-light">
                        Aşağıda bilgileri bulunan <strong>{{ details.ReportNumber }}</strong> tutanak numaralı trafik cezası kaydının <strong>düzenlenmesi</strong> için onayınız gerekmektedir.
                    </div>
                </b-alert>
            </div>

            <b-row>
                <b-col md="6">
                    <b-card title="Personel ve Ceza Bilgileri" class="mb-0">
                        <table class="table table-sm table-striped table-bordered mb-0">
                            <tbody>
                                <tr>
                                    <th class="w-50 bg-lightest-muted">Personel Ad Soyad</th>
                                    <td class="font-weight-bold">{{ details.EmployeeFullName || "-" }}</td>
                                </tr>
                                <tr>
                                    <th class="bg-lightest-muted">Personel T.C. Kimlik No</th>
                                    <td>{{ details.EmployeeIdentityNumber || "-" }}</td>
                                </tr>
                                <tr>
                                    <th class="bg-lightest-muted">Personel Sicil Numarası</th>
                                    <td>{{ details.EmployeeRegistrationCode || "-" }}</td>
                                </tr>
                                <tr>
                                    <th class="bg-lightest-muted">Personel Kıdemi (Yıl)</th>
                                    <td>{{ details.EmployeeWorkingYears }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card>
                </b-col>
                <b-col md="6">
                    <b-card title="Ceza Finansal Özeti" class="mb-0">
                        <table class="table table-sm table-striped table-bordered mb-0">
                            <tbody>
                                <tr>
                                    <th class="w-50 bg-lightest-muted">Toplam Ceza Tutarı</th>
                                    <td class="font-weight-bold">{{ details.TotalAmount | currency }}</td>
                                </tr>
                                <tr>
                                    <th class="bg-lightest-muted">Personele Yansıtılan</th>
                                    <td>{{ details.EmployeeAmount | currency }}</td>
                                </tr>
                                <tr>
                                    <th class="bg-lightest-muted">Firmanın Karşıladığı</th>
                                    <td>{{ details.CompanyAmount | currency }}</td>
                                </tr>
                                <tr>
                                    <th class="bg-lightest-muted">Personelin Toplam Ceza Tutarı</th>
                                    <td>{{ details.TotalAllEmployeeTrafficFinesAmount | currency }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card>
                </b-col>
                <b-col md="6">
                    <b-card title="Değişim Bilgileri" class="mb-0">
                        <table class="table table-sm table-striped table-bordered mb-0">
                            <thead>
                                <th class="bg-light-primary">Değişiklik İstenen Alan</th>
                                <th class="bg-light-danger">Eski Değer</th>
                                <th class="bg-light-success">Yeni Değer</th>
                            </thead>
                            <tbody>
                                <tr v-for="d in details.ChangeRequests" :key="d.Key">
                                    <th class="w-50">{{ d.Key }}</th>
                                    <td class="font-weight-bold">{{ d.OldValue }}</td>
                                    <td class="font-weight-bold">{{ d.NewValue }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card>
                </b-col>
            </b-row>
            <div class="px-2">
                <div class="description-box mt-0 mb-2">
                    <h6 class="font-weight-bold mb-50">Açıklama</h6>
                    <p v-if="details.Description" class="mb-0 pl-50">
                        {{ details.Description }}
                    </p>
                    <p v-else class="text-muted font-italic pl-50 mb-0">Açıklama eklenmemiştir.</p>
                </div>
            </div>
        </div>

        <div class="card-footer text-right pb-0 mb-0">
            <b-button variant="danger" class="mr-2 mb-0 mt-1" v-on:click="$emit('reject')" :disabled="processing"> <b-spinner v-if="processing" small></b-spinner> Reddet </b-button>
            <b-button variant="success" class="mb-0 mt-1" v-on:click="$emit('approve')" :disabled="processing"> <b-spinner v-if="processing" small></b-spinner> Onayla </b-button>
        </div>
    </b-card>

    <b-card v-else>
        <b-alert show variant="warning">Detay bilgileri yüklenemedi.</b-alert>
    </b-card>
</template>

<script>
import { BAlert, BCard, BButton, BSpinner, BRow, BCol } from "bootstrap-vue";

export default {
    components: {
        BAlert,
        BCard,
        BButton,
        BSpinner,
        BRow,
        BCol,
    },
    props: {
        details: { type: Object, default: null },
        processing: { type: Boolean, default: false },
    },
    filters: {
        currency(value) {
            if (typeof value !== "number") {
                return value || "0,00 ₺";
            }
            return value.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
    },
};
</script>

<style scoped>
.bg-lightest-muted {
    background-color: #f9f9f9 !important;
    border-color: #eaeaea;
    border-style: solid;
    border-width: 1px;
}

.dark-layout .bg-lightest-muted {
    background-color: #3b425365 !important;
    border-color: #434b56;
}
</style>
